import { Eye, EyeOff } from "lucide-react";
import Button from "./Button";
import { forwardRef, useEffect, useState } from "react";
import { Input as InputMT } from "@material-tailwind/react";

const PasswordInput = forwardRef(
  (
    {
      type = "text",
      placeholder = "",
      className = "",
      disabled = false,
      value,
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    // const { required } = inputProps;
    console.log("value----", value);

    const EyeIcon = showPassword ? Eye : EyeOff;

    return (
      <>
        <div className="relative">
          <InputMT
            className={`peer-placeholder-shown:placeholder-sub peer-disabled:peer-placeholder-shown:placeholder-sub text-base placeholder:text-skin-gray text-skin-base border-skin-line focus:border-skin-line placeholder-shown:border-skin-line placeholder-shown:border-t-skin-line focus:ring-0 ${className}`}
            labelProps={{
              className:
                "peer-placeholder-shown:font-mulilight peer-focus:text-skin-base text-[14px] peer-focus:text-sm peer-focus:font-mulisemibold peer-focus:text-skin-base peer-placeholder-shown:text-skin-line peer-focus:before:border-skin-line before:border-t-line after:border-t-line font-muli peer-focus:after:border-skin-line text-skin-base peer-placeholder-shown:text-base peer-placeholder-shown:leading-[3.45]",
            }}
            label={props.label || "Field Label"}
            ref={ref}
            type={showPassword ? "text" : "password"}
            required={false}
            disabled={disabled}
            defaultValue={value}
            // readOnly
            // {...field}
            {...props}
            color="blue"
          />
          <Button
            className="absolute bottom-2 right-4"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <EyeIcon color="gray" size={20} />
          </Button>
        </div >
      </>
      // <div>
      //   <div className="relative">
      //     {label ? (
      //       <div
      //         className={`my-1 ${required ? "required-input" : ""}  ${labelCls}`}
      //       >
      //         {label}
      //       </div>
      //     ) : null}

      //     <input
      //       type={showPassword ? "text" : "password"}
      //       className={`border font-mulibold text-secondary border-gray-300 focus:ring-[#005F73] ${
      //         error ? "border-red-400" : "border-gray-300"
      //       } rounded-md w-full px-2 py-2 ${inputCls}`}
      //       {...inputProps}
      //       required={false}
      //     />

      //     <Button
      //       className="absolute bottom-2 right-4"
      //       onClick={() => setShowPassword((prev) => !prev)}
      //     >
      //       <EyeIcon color="gray" size={20} />
      //     </Button>
      //   </div>

      //   {error ? <div className="text-red-600 pt-2 text-sm">{error}</div> : null}
      // </div>
    )
  }
);

export default PasswordInput;
